import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '首页',
        auth: true
      }
    },
    // {
    //   path: '/signup',
    //   name: 'signup',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/Signup.vue'),
    //   meta: {
    //     title: '注册',
    //     auth: false
    //   }
    // },
    {
      path: '/signin',
      name: 'signin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Signin.vue'),
      meta: {
        title: '登录',
        auth: false
      }
    },
    {
      path: '/articles',
      name: 'articles',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Articles.vue'),
      meta: {
        title: '况客研究',
        auth: true
      }
    },
    {
      path: '/focuses',
      name: 'focuses',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Focuses.vue'),
      meta: {
        title: '轮播图',
        auth: true
      }
    },
    {
      path: '/categories',
      name: 'categories',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Categories.vue'),
      meta: {
        title: '文章分类',
        auth: true
      }
    },
    {
      path: '*',
      name: 'nopage',
      component: Home,
      meta: {
        title: '首页',
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log(to)

  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '况客基金'
  }

  if (to.meta.auth) {
    if (!sessionStorage.token) {
      window.location.href = '/signin/'
    }
  }
  next()
})

export default router
